import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        backgroundColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        textAlign: 'center',
        // fontStyle: 'bold',
        flexGrow: 1,
    },
    description: {
        width: '60%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'center',
        fontFamily: 'NotoNastaliqUrdu',
    },
    qty: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'center',
        fontFamily: 'NotoNastaliqUrdu',
    },
    rate: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'center',
        paddingRight: 8,
        fontFamily: 'NotoNastaliqUrdu',
    },
    amount: {
        width: '20%',
        textAlign: 'center',
        paddingRight: 8,
        fontFamily: 'NotoNastaliqUrdu',
    },
});

const InvoiceTableHeader = () => (
    <View style={styles.container}>
        <Text style={styles.amount}>قیمت</Text>
        <Text style={styles.rate}>نرخ</Text>
        <Text style={styles.qty}>تعداد</Text>
        <Text style={styles.description}>پروڈکٹ کا نام</Text>
        <Text style={styles.qty}>نمبر</Text>
    </View>
);

export default InvoiceTableHeader